import { Facebook } from "lucide-react";
import { BRAND } from "@/lib/api";
import { businessWaLink, formatBusinessNumber, WhatsAppIcon } from "@/lib/whatsapp";

export const Footer = () => (
  <footer className="bg-navy text-slate-300" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt={`${BRAND.name} logo`} className="h-12 w-12 rounded-xl object-cover shadow-md" />
          <div>
            <p className="font-heading font-extrabold text-white text-lg">{BRAND.name}</p>
            <p className="text-[10px] tracking-[0.18em] font-semibold text-[var(--green-500)]">{BRAND.badge}</p>
          </div>
        </div>
        <p className="mt-4 text-sm leading-relaxed max-w-sm">{BRAND.tagline}</p>
      </div>
      <div>
        <p className="text-white font-bold mb-3">Servicios</p>
        <ul className="space-y-2 text-sm">
          <li>Seguro de vida IUL</li>
          <li>Planes de retiro y legado</li>
          <li>Seguro de auto (bono de $50)</li>
          <li>Asesoría financiera en español</li>
        </ul>
      </div>
      <div>
        <p className="text-white font-bold mb-3">Contáctanos</p>
        <div className="flex flex-wrap gap-2">
          <a
            href={businessWaLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] transition-colors px-4 py-2 text-sm font-semibold text-white"
            data-testid="footer-whatsapp-link"
          >
            <WhatsAppIcon className="h-4 w-4" /> WhatsApp {formatBusinessNumber()}
          </a>
          <a
            href={BRAND.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors px-4 py-2 text-sm font-semibold text-white"
            data-testid="footer-facebook-link"
          >
            <Facebook className="h-4 w-4" /> Facebook
          </a>
        </div>
        <p className="mt-6 text-xs text-slate-400 leading-relaxed">
          La información es de carácter educativo y no constituye asesoría financiera, fiscal o legal.
          Los productos IUL están sujetos a aprobación y a los términos de la aseguradora.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 text-xs flex flex-col sm:flex-row items-center justify-between gap-2">
        <span>© {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.</span>
        <a href="/admin/leads" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-admin-link">
          Panel de leads
        </a>
      </div>
    </div>
  </footer>
);
